import CloseOutline from '@mollie/ui-assets/icons/utilitarian/CloseOutline';
import CheckOutline from '@mollie/ui-assets/icons/utilitarian/CheckOutline';
import Search from '@mollie/ui-assets/icons/utilitarian/Search';
import Loader from '@mollie/ui-assets/icons/utilitarian/Loader';
import clsx from 'clsx';
import React from 'react';
import { Box } from '../Box';
import { ButtonGroup } from '../ButtonGroup';
import { TextContainer } from '../TextContainer';
import { Icon } from '../Icon';
import { Text } from '../Text';
import './PageState.css';
export function PageState(props) {
    const { children, className, title, description, actions, variant = 'error', icon = {
        error: CloseOutline,
        success: CheckOutline,
        empty: Search,
        loading: Loader,
    }[variant], ...rest } = props;
    return (React.createElement(Box.Restricted, { ...rest, className: clsx('mollie-ui-page-state', {
            [`mollie-ui-page-state--${variant}`]: variant,
        }, className) },
        icon && (React.createElement(Icon, { src: icon, spinning: icon === Loader, className: "mollie-ui-page-state-icon" })),
        React.createElement(TextContainer, { textAlign: "center" },
            title && (React.createElement(Text, { className: "mollie-ui-page-state-title", variant: "heading-title-3" }, title)),
            description && (React.createElement("div", { className: "mollie-ui-page-state-description" }, description))),
        children,
        actions && (React.createElement(ButtonGroup, { size: "medium", inverse: { extraSmall: true }, alignSelf: { extraSmall: 'stretch' } }, actions))));
}
//# sourceMappingURL=PageState.js.map